import { useLanguage } from "@/clientWeb/i18n/LanguageContext"
import { Button } from "@/clientWeb/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/clientWeb/components/ui/dialog"

interface MarkPastOccupiedDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** End the meeting for everyone, then mark it past. */
  onConfirm: () => void
  busy?: boolean
}

/**
 * Shown when Mark as Past is refused because people are still in the room.
 * A live meeting is not filed under Past around the people in it: the host
 * ends it for everyone first, or leaves it running. Worded as old inMeet
 * worded it, plus the one button old inMeet did not have.
 */
export function MarkPastOccupiedDialog({ open, onOpenChange, onConfirm, busy }: MarkPastOccupiedDialogProps) {
  const { t } = useLanguage()

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="xs">
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t("meetings.markPastLiveTitle")}</DialogTitle>
          <DialogDescription>{t("meetings.markPastLiveDesc")}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>
            {t("common.cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {busy ? t("meetings.endingAndMarkingPast") : t("meetings.endAndMarkPast")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
